import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../../models/api.model';
import { Upgrade } from '../models/upgrade.model';

@Injectable({
  providedIn: 'root',
})
export class UpgradeService {
  private http = inject(HttpClient);

  private apiRoot = '/bo/event-upgrades';

  public getAll$(page?: number): Observable<ApiResponse<Upgrade[]>> {
    let query = '';
    if (page) {
      query = '?page=' + page;
    }
    return this.http.get<ApiResponse<Upgrade[]>>(
      environment.apiURl + `${this.apiRoot}${query}`
    );
  }

  public get$(id: number): Observable<ApiResponse<Upgrade>> {
    return this.http.get<ApiResponse<Upgrade>>(
      environment.apiURl + `${this.apiRoot}/${id}`
    );
  }

  public create$(
    body: Upgrade,
    nm: Array<string | number>
  ): Observable<ApiResponse<Upgrade>> {
    let formData: FormData = new FormData();

    formData.append('active', body.active.toString());
    formData.append('name', body.name);
    formData.append('description', body.description);
    formData.append('minSeatsToShow', `${body.minSeatsToShow}`);
    formData.append('goal', `${body.goal}`);
    if (nm) {
      if (nm.length) {
        nm.forEach(i => {
          formData.append('events[]', i.toString());
        });
      } else {
        formData.append('events', '[]');
      }
    }

    return this.http.post<ApiResponse<Upgrade>>(
      environment.apiURl + `${this.apiRoot}`,
      formData
    );
  }

  public delete$(id: number): Observable<ApiResponse<Pick<Upgrade, 'id'>>> {
    return this.http.delete<ApiResponse<Pick<Upgrade, 'id'>>>(
      environment.apiURl + `${this.apiRoot}/${id}`
    );
  }

  public update$(
    body: Upgrade,
    nm: Array<string | number>
  ): Observable<ApiResponse<Upgrade>> {
    let formData: FormData = new FormData();

    formData.append('active', body.active.toString());
    if (body.name) {
      formData.append('name', body.name);
    }
    if (body.description) {
      formData.append('description', body.description);
    }
    if (body.minSeatsToShow) {
      formData.append('minSeatsToShow', `${body.minSeatsToShow}`);
    }
    if (body.goal) {
      formData.append('goal', `${body.goal}`);
    }
    if (nm) {
      if (nm.length) {
        nm.forEach(i => {
          formData.append('events[]', i.toString());
        });
      } else {
        formData.append('events', '[]');
      }
    }
    return this.http.patch<ApiResponse<Upgrade>>(
      environment.apiURl + `${this.apiRoot}/${body.id}`,
      formData
    );
  }
}
